export type CookiebotConsentState = 'known' | 'timeout';

export const CONSENT_KNOWN_TIMEOUT_MS = 3000;

const CONSENT_KNOWN_EVENTS = ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline'];

// Cookiebot is injected asynchronously after React boots, so on a fresh document
// a dataLayer push can race consent restoration and make GTM tags fire cookieless.
// Resolves 'known' once Cookiebot reports a response (restored, accepted, or
// declined — a decline is a known state too), or 'timeout' when it never does
// (e.g. blocked by an ad blocker) so callers can push anyway and never lose an event.
export const waitForCookiebotConsent = (): Promise<CookiebotConsentState> => {
	if (window.Cookiebot?.hasResponse) {
		return Promise.resolve('known');
	}

	return new Promise((resolve) => {
		const cleanups: Array<() => void> = [];
		const settle = (result: CookiebotConsentState) => {
			// biome-ignore lint/suspicious/useIterableCallbackReturn: pre-existing callback shape; changing returns needs per-site behavior review
			cleanups.forEach((cleanup) => cleanup());
			resolve(result);
		};

		const timeoutId = setTimeout(() => settle('timeout'), CONSENT_KNOWN_TIMEOUT_MS);
		cleanups.push(() => clearTimeout(timeoutId));

		const onConsentKnown = () => settle('known');
		CONSENT_KNOWN_EVENTS.forEach((event) => {
			window.addEventListener(event, onConsentKnown);
			cleanups.push(() => window.removeEventListener(event, onConsentKnown));
		});
	});
};
